var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusHigh = function SvgStatusHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F44",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18.417a4.375 4.375 0 0 1-2.997-7.562c.783-.737 2.705-2.063 2.414-4.98 3.5 2.333 5.25 4.667 1.75 8.167.583 0 1.458 0 2.917-1.441.157.45.291.935.291 1.44A4.375 4.375 0 0 1 12 18.418"
  })));
};
export default SvgStatusHigh;